
import SearchComponent from './SearchComponent.vue'

const NSearch = {
    install:function(Vue) {
        Vue.component('n-search',SearchComponent)
    }
}

export default NSearch